import axios from 'axios';

var parseString = require('xml2js').parseString;

export class AxiosServices {  

  ///---Base Service--///

  async post(url,body,headers = {}){      
    const res = await axios.post(url, body, headers )        
    let jsonResult;
      parseString(res.data, function (err, res){
          jsonResult = JSON.parse(res.string._)                    
      });
    return jsonResult;        
    }

}
const axiosServices = new AxiosServices();
export default axiosServices;
